import CourseCard from './CourseCard.vue';
import Live from './Live.vue';
import { Empty } from 'zhs-components';
import { ArrowRight, ArrowDown } from '@element-plus/icons-vue';
import CommonTitle from './CommonTitle.vue';
export default {
  components: {
    CourseCard,
    Live,
    Empty,
    ArrowRight,
    ArrowDown,
    CommonTitle
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    },
    isTop: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.getAuth();
    this.getTypeList();
  },

  watch: {
    typeId: {
      handler(val) {
        this.getHomeCourseList();
      },

      immediate: true
    }
  },

  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      classId: undefined,
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: ''
    };
  },

  methods: {
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeMooc({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.typeId
      });
      console.log(homeCourse);
      this.homeCourseList = homeCourse;
    },

    async getAuth() {
      const res2 = await this.$http.getConfigList();
      this.authType = res2.find(item => item.code == '10401') ? res2.find(item => item.code == '10401').auth_type : 0;
    },

    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.menu_id
      });
      this.typeList = res;
    },

    searchCourseList(id) {
      this.typeId = id;
    },

    handleMore() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      let nav = navItemInfo.find(item => item.function_id == '18300');

      if (nav) {
        window.location.href = `/teacherList.html?menuId=${nav.id}&name=${nav.nav_name}&tab=${this.menu.menu_id}`;
      }
    }

  }
};